export default "__VITE_ASSET__CsNAJsU1__"